import React from "react";
import { useSelector } from "react-redux";
import { Navbar } from "reactstrap";
import classnames from "classnames";
import NavbarBookmarks from "./NavbarBookmarks";
import NavbarUser from "./NavbarUser";
import userImg from "assets/img/user.png";
import { getUser } from "../../../utility/Common";
import { useDispatch } from "react-redux";
import { changeMode } from "../../../redux/actions/customizer";

import {
  Sun,
  Moon,
  Monitor,
  Award,
  Droplet,
  Hexagon,
  Sunrise,
} from "react-feather";

import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

const ThemeNavbar = (props) => {
  const dispatch = useDispatch();

  const theme = useSelector((state) => state.customizer.customizer.theme);
  const colorsArr = ["primary", "danger", "success", "info", "warning", "dark"];
  const navbarTypes = ["floating", "static", "sticky", "hidden"];
  const userData = useSelector((state) => state.auth?.login);
  const [themeMenu, setThemeMenu] = React.useState(false);

  const toggleThemeMenu = () => {
    setThemeMenu(!themeMenu);
  };

  const changeTheme = (mode) => {
    dispatch(changeMode(mode));

    localStorage.setItem("theme", mode);
  };

  const toggleTheme = () => {
    const newTheme = theme === "dark" ? "light" : "dark";

    dispatch(changeMode(newTheme));

    localStorage.setItem("theme", newTheme);
  };
  return (
    <React.Fragment>
      <div className="content-overlay" />
      <div className="header-navbar-shadow" />
      <Navbar
        className={classnames(
          "header-navbar navbar-expand-lg navbar navbar-with-menu navbar-shadow",
          {
            "navbar-light":
              props.navbarColor === "default" ||
              !colorsArr.includes(props.navbarColor),
            "navbar-dark": colorsArr.includes(props.navbarColor),
            "bg-primary":
              props.navbarColor === "primary" && props.navbarType !== "static",
            "bg-danger":
              props.navbarColor === "danger" && props.navbarType !== "static",
            "bg-success":
              props.navbarColor === "success" && props.navbarType !== "static",
            "bg-info":
              props.navbarColor === "info" && props.navbarType !== "static",
            "bg-warning":
              props.navbarColor === "warning" && props.navbarType !== "static",
            "bg-dark":
              props.navbarColor === "dark" && props.navbarType !== "static",
            "d-none": props.navbarType === "hidden" && !props.horizontal,
            "floating-nav":
              (props.navbarType === "floating" && !props.horizontal) ||
              (!navbarTypes.includes(props.navbarType) && !props.horizontal),
            "navbar-static-top":
              props.navbarType === "static" && !props.horizontal,
            "fixed-top": props.navbarType === "sticky" || props.horizontal,
            scrolling: props.horizontal && props.scrolling,
          },
        )}
      >
        <div className="navbar-wrapper">
          <div className="navbar-container content">
            <div
              className="navbar-collapse d-flex justify-content-between align-items-center"
              id="navbar-mobile"
            >
              <div className="bookmark-wrapper">
                <NavbarBookmarks
                  sidebarVisibility={props.sidebarVisibility}
                  handleAppOverlay={props.handleAppOverlay}
                />
              </div>
              {props.horizontal ? (
                <div className="logo d-flex align-items-center">
                  {/* <div className="brand-logo mr-50"></div> */}
                  <h2 className="text-primary brand-text mb-0">SIRS</h2>
                </div>
              ) : null}
              {/* <NavbarUser
                // handleAppOverlay={props.handleAppOverlay}
                // changeCurrentLang={props.changeCurrentLang}
                // userName={getUser()?.nama}
                // userRole={getUser()?.role_dof}
                // userImg={userImg}
              /> */}
              <div className="d-flex align-items-center">
                {/* <div
                  className="mr-2"
                  style={{ cursor: "pointer" }}
                  onClick={toggleTheme}
                >
                  {theme === "dark" ? (
                    <Sun color="#FFD54F" size={20} />
                  ) : (
                    <Moon color="#555" size={20} />
                  )}
                </div> */}

                <Dropdown
                  isOpen={themeMenu}
                  toggle={toggleThemeMenu}
                  className="mr-2"
                >
                  <DropdownToggle color="primary" outline caret>
                    {theme === "light" && <Sun size={16} />}
                    {theme === "dark" && <Moon size={16} />}
                    {theme === "semi-dark" && <Monitor size={16} />}
                    {theme === "royal" && <Award size={16} />}
                    {theme === "ocean" && <Droplet size={16} />}
                    {theme === "emerald" && <Hexagon size={16} />}
                    {theme === "sunset" && <Sunrise size={16} />}

                    <span className="ml-1">
                      {theme === "light" && "Light Theme"}
                      {theme === "dark" && "Dark Theme"}
                      {theme === "semi-dark" && "Semi Dark Theme"}
                      {theme === "royal" && "Royal Theme"}
                      {theme === "ocean" && "Ocean Theme"}
                      {theme === "emerald" && "Emerald Theme"}
                      {theme === "sunset" && "Sunset Theme"}
                    </span>
                  </DropdownToggle>

                  <DropdownMenu right>
                    <DropdownItem onClick={() => changeTheme("light")}>
                      <Sun size={16} className="mr-1" />
                      Light
                    </DropdownItem>

                    <DropdownItem onClick={() => changeTheme("dark")}>
                      <Moon size={16} className="mr-1" />
                      Dark
                    </DropdownItem>

                    <DropdownItem onClick={() => changeTheme("semi-dark")}>
                      <Monitor size={16} className="mr-1" />
                      Semi Dark
                    </DropdownItem>

                    <DropdownItem onClick={() => changeTheme("royal")}>
                      <Award size={16} className="mr-1 text-purple" />
                      Royal
                    </DropdownItem>

                    <DropdownItem onClick={() => changeTheme("ocean")}>
                      <Droplet size={16} className="mr-1 text-info" />
                      Ocean
                    </DropdownItem>

                    <DropdownItem onClick={() => changeTheme("emerald")}>
                      <Hexagon size={16} className="mr-1 text-success" />
                      Emerald
                    </DropdownItem>

                    <DropdownItem onClick={() => changeTheme("sunset")}>
                      <Sunrise size={16} className="mr-1 text-warning" />
                      Sunset
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>

                <NavbarUser
                  handleAppOverlay={props.handleAppOverlay}
                  changeCurrentLang={props.changeCurrentLang}
                  userName={getUser()?.nama}
                  userRole={getUser()?.role_dof}
                  userImg={userImg}
                />
              </div>
            </div>
          </div>
        </div>
      </Navbar>
    </React.Fragment>
  );
};

export default ThemeNavbar;
